import { ALL_SOURCES, ArrayResolution } from '@fabric-ui/components';
import { DwQueryRequest, ProjectionID } from '../../views/CustomDashboards/types';

export const NESTED_CURRENT_STATUS_FIELD = 'current_status.name';
export const CURRENT_STATUS_FIELD = 'current_status';

export const SOURCES_INITIAL_LIMIT = 3;

export const generateSourcesValuesQuery = ({
  projectionId,
  fieldName,
  avalorKey,
  projAliasPath,
  entityPathAlias,
  sources = [],
  showAll,
}: {
  projectionId: ProjectionID;
  fieldName: string;
  entityPathAlias: string;
  projAliasPath: string;
  avalorKey: string;
  sources: (typeof ALL_SOURCES | string)[];
  showAll: boolean;
}): DwQueryRequest => ({
  projectionId,
  select: {
    dims: [],
    metrics: [
      {
        name: showAll
          ? `COLLECT(json_object(value: ${entityPathAlias}.sources.${fieldName}, items: ${entityPathAlias}.sources.source_names))`
          : `TOP_K_BY(json_object(value: ${entityPathAlias}.sources.${fieldName}, items: ${entityPathAlias}.sources.source_names), ${entityPathAlias}.sources.${fieldName}, ${SOURCES_INITIAL_LIMIT})`,
        alias: 'sources',
      },
      {
        name: sources.includes(ALL_SOURCES)
          ? `COUNT(${entityPathAlias}.sources.source_names)`
          : `COUNT_IF(${entityPathAlias}.sources.source_names, ${entityPathAlias}.sources.source_names in (${sources
              .map(item => `'${item}'`)
              .join()}))`,
        alias: 'totalCount',
      },
    ],
  },
  distinct: true,
  sorting: [],
  filter: {
    and: {
      operands: [
        {
          expression: {
            fieldName: `${projAliasPath}._key`,
            stringCondition: {
              equals: avalorKey,
            },
          },
        },
        ...(sources.includes(ALL_SOURCES)
          ? []
          : [
              {
                expression: {
                  fieldName: `${entityPathAlias}._key`,
                  arrayCondition: {
                    resolution: ArrayResolution.ANY,
                    underlying: {
                      fieldName: `${entityPathAlias}.sources.source_names`,
                      stringCondition: {
                        in: { values: sources },
                      },
                    },
                  },
                },
              },
            ]),
      ],
    },
  },
});

export enum TargetGroups {
  MATCHING_TICKET = 1,
  NOT_MATCHING_TICKET = 2,
}
